export enum Stato {
    abilitato = 'ABILITATO',
    disabilitato = 'DISABILITATO'
}